import React from "react";
import {
  Button,
  Flex,
  BodyText,
  HeaderText,
  SelectField,
  Icon
} from "@fanduel/formation-react-components";
import {
  ArrowsChevronLeft,
  ArrowsChevronRight
} from "@fanduel/formation-react-icons";
import { COLORS, SPACING } from "@fanduel/formation-theming";
import { PaginationControlsProps } from "./types";

const PaginationControls: React.FC<PaginationControlsProps> = ({
  qaLabel,
  currentPage,
  totalPages,
  recordsByPage,
  recordsByPageOptions = [],
  goToPrevPage,
  goToNextPage,
  setRecordsByPage,
  isPrevEnabled,
  isNextEnabled
}) => (
  <Flex
    paddingBottom={SPACING.space4}
    paddingTop={SPACING.space4}
    justify="space-between"
    align="center"
    justifyContent="center"
    gap={SPACING.space8}
  >
    <Flex
      data-qa-label={`${qaLabel}-pagination-controls`}
      align="center"
      gap={SPACING.space8}
    >
      <Button
        data-qa-label={`${qaLabel}-prev-button`}
        variant="link"
        size="small"
        label="Prev"
        aria-label="Prev"
        disabled={!isPrevEnabled}
        onClick={goToPrevPage}
        iconLeft={
          <Icon
            as={ArrowsChevronLeft}
            color={!isPrevEnabled ? COLORS.contentDisabled : COLORS.contentLink}
          />
        }
      />
      <Flex>
        <HeaderText
          data-qa-label={`${qaLabel}-current-page`}
          color={COLORS.contentStrong}
          size="md"
        >
          {currentPage}
        </HeaderText>
        <BodyText color={COLORS.contentStrong} size="lg">
          &nbsp;of {totalPages}
        </BodyText>
      </Flex>
      <Button
        data-qa-label={`${qaLabel}-next-button`}
        variant="link"
        size="small"
        label="Next"
        aria-label="Next"
        disabled={!isNextEnabled}
        onClick={goToNextPage}
        iconRight={
          <Icon
            as={ArrowsChevronRight}
            color={!isNextEnabled ? COLORS.contentDisabled : COLORS.contentLink}
          />
        }
      />
    </Flex>
    {recordsByPageOptions.length > 0 && (
      <SelectField
        id="select-pagination"
        label="Records"
        isCondensed
        value={`${recordsByPage}`}
        onValueChange={(value) => setRecordsByPage(Number(value))}
        // @ts-ignore
        options={recordsByPageOptions}
        css={{
          width: "100px"
        }}
      />
    )}
  </Flex>
);

export default PaginationControls;
